module.exports = __webpack_public_path__ + "media/Slide16.cc15d846.mp3";